import { variant } from 'variant';
import type { VariantOf } from 'variant';
import type { TemplateSource } from './parse-command-options.js';
import type { McpConfigResult } from './components/mcp/getMcpResult.js';

export interface AppData {
  appId: string;
  appName: string;
  namespace?: string;
  codeIdentifier?: string;
}

export interface GenerationData {
  appData: AppData;
  packageName: string;
  template: TemplateSource;
  mcpConfigResult: McpConfigResult;
  environmentVariables: Record<string, string>;
}

export const DeveloperAppsStatus = variant({
  NoApps: {},
  FailedLoadingApps: {},
  Available: {},
});

export type DeveloperAppsStatus = VariantOf<typeof DeveloperAppsStatus>;

export type CreationFlow = 'new' | 'existing';
